import type {ImageField, KeyTextField} from '@prismicio/client'
import {isFilled} from '@prismicio/client'
import {useLinkResolver} from 'prismicio'
import type {ButtonDocumentData} from 'prismicio-types'
import React from 'react'
import {ButtonV2} from 'src/common/ButtonV2'

interface Props {
  eyebrow: KeyTextField
  title: KeyTextField
  desc: KeyTextField
  buttonData: ButtonDocumentData | null | undefined
  backgroundImage: ImageField
  pageUid: string
}

const CtaSection: React.FC<Props> = ({eyebrow, title, desc, buttonData, backgroundImage, pageUid}) => {
  const {linkResolver} = useLinkResolver()

  const buttonHref = buttonData?.link ? linkResolver(buttonData.link, 'top10-cta') : undefined
  const buttonLabel = buttonData?.label

  return (
    <section style={{scrollMarginTop: 64}}>
      <div className="t10-cta-outer">
        <div className="t10-cta-card">
          {isFilled.image(backgroundImage) && (
            <img src={backgroundImage.url} alt={backgroundImage.alt ?? ''} className="t10-cta-bg" />
          )}
          <div className="t10-cta-overlay" />
          <div className="t10-cta-content">
            {eyebrow && (
              <p className="t10-eyebrow" style={{marginBottom: 22}}>
                {eyebrow}
              </p>
            )}
            {title && <h2 className="t10-cta-title">{title}</h2>}
            {desc && <p className="t10-cta-desc">{desc}</p>}
            {buttonLabel && buttonHref && (
              <div className="t10-cta-buttons">
                <ButtonV2
                  href={buttonHref}
                  variant="primary"
                  className="t10-btn-primary"
                  trackingData={{
                    location: 'top10-cta',
                    dataType: 'primary-button',
                    mktgId: buttonData?.marketing_id ?? '',
                    pageName: pageUid,
                  }}
                >
                  {buttonLabel}
                </ButtonV2>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  )
}

export default CtaSection
